const altgrid = {
    numColumns: 4,
    numRows: 7,
    // used for view more feature, view more starts on this slide
    slidesCovered: 18,
    moreSize: 12,
    borderWidth: 15,
    extraRows: 0,
    cellInstances: null,
    cells: {
        // image order as returned are keys
        1: {
            imageNum:0,
            col: 0,
            row: 0,
            size: 1,
            class: 'featured-1',
        },
        2: {
            imageNum: 1,
            col: 1,
            row: 0,
            size: 1,
        },
        3: {
            imageNum: 2,
            col: 2,
            row: 0,
            size: 1,
        },
        4: {
            imageNum: 3,
            col: 3,
            row: 0,
            size: 1,
            class: 'featured-2',
        },
        5: {
            imageNum: 4,
            col: 0,
            row: 1,
            size: 1,
        },
        6: {
            imageNum: 5,
            col: 1,
            row: 1,
            size: 2,
        },
        7: {
            imageNum: 6,
            col: 3,
            row: 1,
            sizeY: 2,
        },
        8: {
            imageNum: 7,
            col: 0,
            row: 2,
            size: 1,
        },
        // 9: {
        //     imageNum: 8,
        //     col: 3,
        //     row: 2,
        //     size: 1,
        // },
        10: {
            imageNum: 9,
            col: 0,
            row: 3,
            sizeX: 2,
        },
        11: {
            imageNum: 10,
            col: 2,
            row: 3,
            sizeX: 2,
        },
        12: {
            imageNum: 11,
            col: 0,
            row: 4,
            sizeX: 2,
            sizeY: 3,
        },
        13: {
            imageNum: 12,
            col: 2,
            row: 4,
            sizeY: 2,
        },
        14: {
            imageNum: 13,
            col: 3,
            row: 4,
        },
        // 15: {
        //     imageNum: 14,
        //     col: 2,
        //     row: 5,
        // },
        16: {
            imageNum: 15,
            col: 3,
            row: 5,
        },
        17: {
            imageNum: 16,
            col: 2,
            row: 6,
        },
        18: {
            imageNum: 17,
            col: 3,
            row: 6,
        },
    }
}

export default altgrid;
